<div (click)="onAvatarClick()" class="avatar-dropdown">
   <div
      kendoTooltip
      [tooltipTemplate]="tooltipTemplate"
      (mouseenter)="showTooltip = true"
      (mouseleave)="showTooltip = false"
      [isTooltipVisible]="showTooltip && !userStatusDropdown.dropdownList.isOpen"
   >
      <samweb-avatar class="avatar-container"></samweb-avatar>

      <ng-template #tooltipTemplate>
         <samweb-agent-status [statusInfo]="currentUserStatusInfo$ | async" [hideIcon]="true"></samweb-agent-status>
      </ng-template>
   </div>

   <samweb-user-status-dropdown
      #userStatusDropdown
      [userId]="userId"
      fxFlex="0 0 auto"
      [isViewSmall]="false"
      class="hide"
   ></samweb-user-status-dropdown>
</div>
